import React, { useState } from 'react';

import { ButtonContainer } from '../../../Button/Button';
import AuthorizationCheckbox from '../../../Checkbox/Checkbox';
import { Input } from '../../../Input/Input';
import { PasswordInput } from '../../../PasswordInput/PasswordInput';
import {
    validateEmail,
    validateFormatEmail,
    validateName,
    validatePassword,
} from '../../../validate';
import { FormTitle } from '../../FormTitle/FormTitle';
import { Form } from '../Form';

export const StepOne = ({
    state,
    updateEmail,
    updateName,
    updatePassword,
    updateAcceptEULA,
    sendValidateFirstStepRequest,
    serverErrors,
}) => {
    const [errors, setErrors] = useState({
        email: null,
        name: null,
        password: null,
    });
    const [errorCheckbox, setErrorCheckbox] = useState(false);

    const subtitle = () => (
        <span>
            {i18next.t('StepOne.return.subtitle.part1')}
            <a href={`${BASE_URL}/login`}>{i18next.t('StepOne.return.subtitle.part2')}</a>
        </span>
    );

    const RegistrationLabel = () => (
        <span>
            {i18next.t('StepOne.return.RegistrationLabel.iAgree')}&ensp;
            <a
                href={`${ENV.BASE_URL}/terms-of-service`}
                target="_blank"
                rel="noreferrer"
                data-id="terms-of-service"
            >
                {i18next.t('StepOne.return.RegistrationLabel.termsService')}
            </a>
            &ensp;{i18next.t('StepOne.return.RegistrationLabel.and')}&ensp;
            <a href={`${ENV.BASE_URL}/privacy`} target="_blank" rel="noreferrer" data-id="privacy">
                {i18next.t('StepOne.return.RegistrationLabel.privacy')}
            </a>
        </span>
    );

    const isAllEmptyFields = !state.name.length && !state.password.length && !state.email.length;
    const isEmptyFields = !state.name.length || !state.password.length || !state.email.length;
    const isButtonDisabled = isAllEmptyFields && !state.acceptEULA;

    return (
        <>
            <FormTitle title={i18next.t('StepOne.return.FormTitle.title')} subtitle={subtitle()} />
            <Form>
                <Input
                    label={i18next.t('StepOne.return.input.name.label')}
                    type="text"
                    error={!!errors.name}
                    helperText={errors.name ?? ' '}
                    value={state.name}
                    onChange={(e) => {
                        updateName(e.target.value);
                        setErrors((prevState) => ({
                            ...prevState,
                            name: validateName(e.target.value),
                        }));
                    }}
                    onBlur={(e) => {
                        setErrors((prevState) => ({
                            ...prevState,
                            name: validateName(e.target.value),
                        }));
                    }}
                    inputProps={{
                        'data-id': 'register-name',
                    }}
                />
                <Input
                    label={i18next.t('StepOne.return.input.email.label')}
                    error={!!errors.email || !!serverErrors.email}
                    helperText={(errors.email || serverErrors.email) ?? ' '}
                    value={state.email}
                    onChange={(e) => {
                        updateEmail(e.target.value);
                        const error = validateEmail(e.target.value);
                        setErrors((prevState) => ({
                            ...prevState,
                            email: error,
                        }));
                    }}
                    onBlur={(e) => {
                        const error = validateEmail(e.target.value);
                        setErrors((prevState) => ({
                            ...prevState,
                            email: error,
                        }));
                        if (error === null) {
                            setErrors((prevState) => ({
                                ...prevState,
                                email: validateFormatEmail(e.target.value),
                            }));
                        }
                    }}
                    inputProps={{
                        'data-id': 'register-email',
                    }}
                />
                <PasswordInput
                    updatePassword={updatePassword}
                    validatePassword={validatePassword}
                    setErrors={setErrors}
                    errors={errors}
                    passwordValue={state.password}
                    label={i18next.t('StepOne.return.PasswordInput.label')}
                    id="register-password"
                    tooltip
                />
                <AuthorizationCheckbox
                    saveCheckbox={updateAcceptEULA}
                    value={state.acceptEULA}
                    errorCheckbox={errorCheckbox}
                    label={<RegistrationLabel />}
                    flexAlign="center"
                    position="start"
                    required
                />
                <ButtonContainer
                    textButton={i18next.t('StepOne.return.ButtonContainer.textButton')}
                    disable={isButtonDisabled}
                    onClick={() => {
                        if (!isAllEmptyFields) {
                            setErrorCheckbox(true);
                        }
                        setErrors((prevState) => ({
                            ...prevState,
                            name: validateName(state.name),
                            email: validateEmail(state.email) || validateFormatEmail(state.email),
                            password: validatePassword(state.password),
                        }));
                        if (!isEmptyFields) {
                            sendValidateFirstStepRequest();
                        }
                    }}
                    needShowLoader={state.needShowLoader}
                />
            </Form>
        </>
    );
};
